import useEffectOnce from './useEffectOnce';

const useCleanupEffect = effect => {
  useEffectOnce(() => {
    return () => {
      effect();
    };
  });
};

export default useCleanupEffect;
